<template>
  <a class="button">
    {{ text }}
  </a>
</template>

<script>
export default {
  name: "LinkButton",
  props: {
    text: String
  }
};
</script>
